export default __webpack_public_path__ + "static/media/seal-csd.9b8fe3b9.png";